export default {
  zh: {
    account: {
      account: '个人中心',
      nickname: '申请人 : ',
      email: '邮箱 : ',
      password: '密码 : ',
      phone: '手机号码 : ',
      only: '(仅适用于中国大陆)',
      receiptLanguage: '收件语言 : ',
      residentialAddress: '住址 : ',
      chinese: '中文',
      english: '英文',
      back: '返回'
    },
    bind: {
      bind: '绑定手机',
      title: '手机号绑定信息填写',
      succeed: '绑定成功',
      bindBut: '绑定'
    },
    password: {
      password: '修改密码',
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      change: '修改',
      inconformity: '密码不一致'
    },
    email: {
      email: '修改邮箱',
      newEmail: '新邮箱',
      send: '发送验证',
      verify: '邮件已发送, 待验证'
    }
  },
  en: {
    account: {
      account: 'Personal Settings',
      nickname: 'Applicant name : ',
      email: 'Email : ',
      password: 'Password : ',
      phone: 'Mobile phone : ',
      only: '(Only applicable to Mainland China)',
      receiptLanguage: 'Email language : ',
      residentialAddress: 'Residential Address : ',
      chinese: 'Chinese',
      english: 'English',
      back: 'Back'
    },
    bind: {
      bind: 'Bind phone',
      title: 'Bind phone (please enter your mobile phone number):',
      succeed: 'Binding success',
      bindBut: 'OK'
    },
    password: {
      password: 'Change password',
      oldPassword: 'Old password',
      newPassword: 'New password',
      confirmPassword: 'Confirm the new password',
      change: 'Change',
      inconformity: 'Inconsistent passwords'
    },
    email: {
      email: 'Change email',
      newEmail: 'New email',
      send: 'Send verification',
      verify: 'The email has been sent and needs to be verified'
    }
  }
}
